import React from "react"
import {
    Button,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader
} from "reactstrap"

const Feedback = props => {
    const { isOpen, toggle } = props
    return (
        <Modal
            isOpen={isOpen}
            role="dialog"
            autoFocus={true}
            centered={true}
            className="exampleModal"
            tabIndex="-1"
            toggle={toggle}
        >
            <div className="modal-content">
                <ModalHeader toggle={toggle}>Leave Feedback</ModalHeader>
                <ModalBody>
                    <div className="mt-2">
                        <div className="position-relative">
                           <input id="reviewInputbox" type="textarea"></input>      
                        </div>                 
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button color="primary">Save</Button>
                    <Button type="button" color="secondary" onClick={toggle}>
                        Close
                    </Button>
                </ModalFooter>
            </div>
        </Modal>

    )
}

export default Feedback